module.exports = __webpack_public_path__ + "fonts/Nunito-VariableFont_wght.85636825.ttf";